module.exports = __webpack_public_path__ + "img/btn_menu_wxz.e8946c04.png";